module.exports = __webpack_public_path__ + "static/media/highland-park-bg.47bde34f.jpg";